/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_8_AInputs */

const en_mk_faq_8_a = /** @type {(inputs: Mk_Faq_8_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Your workspace content is sent to the model provider only as context while an agent works, and we do not use it for training. The details are on the Security & data page.`)
};

const id_mk_faq_8_a = /** @type {(inputs: Mk_Faq_8_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak. Isi workspace dikirim ke penyedia model hanya sebagai konteks saat agen bekerja, dan kami tidak memakainya untuk pelatihan. Rinciannya ada di halaman Keamanan & data.`)
};

/**
* | output |
* | --- |
* | "No. Your workspace content is sent to the model provider only as context while an agent works, and we do not use it for training. The details are on the Secu..." |
*
* @param {Mk_Faq_8_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_8_a = /** @type {((inputs?: Mk_Faq_8_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_8_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_8_a(inputs)
	return en_mk_faq_8_a(inputs)
});